import { Heading } from './Heading';
import { Para } from './Para';
import { Spinner } from './Spinner';
import { Stack } from './Stack';

type Props = {
  title?: string;
  message?: string;
};

export function Loader({ title = 'DRYCUT', message = 'Loading...' }: Props): JSX.Element {
  return (
    <Stack gap={5} className="min-h-96 justify-center">
      <Heading variant="h2">{title}</Heading>
      <Stack direction="row" gap={1} className="justify-center">
        <Spinner className="w-7 h-7 text-zinc-400 mr-3" />
        <Para className="text-zinc-500 hidden lg:block">{message}</Para>
      </Stack>
    </Stack>
  );
}
